








import Vue from "vue";
import { mapGetters } from "vuex";
import { DEVICE_TREE_CONSTANTS as K } from "@/utility/Constants";

export default Vue.extend({
    data() {
        return { K, reload: 0, disabledNode: [] };
    },
    props: ["value", "leaf", "disabled"],
    computed: {
        ...mapGetters(["folderTree"]),
        openAll() {
            return this.$store.getters.folderNames.length < 200;
        },

        selectedFolder: {
            get: function () {
                return this.value;
            },
            set: function (newValue: any) {
                this.$emit("input", newValue);
            },
        },
        editedFolderTree() {
            if (this.folderTree) return JSON.parse(JSON.stringify(this.folderTree));
            return null;
        },
    },
    watch: {
        disabled: {
            handler() {
                if (this.disabled && this.disabled.length && this.folderTree) {
                    for (let node of this.disabledNode) {
                        node.disabled = false;
                    }
                    this.disabledNode = [];
                    for (let root of this.editedFolderTree) {
                        let stack = [];
                        stack.push(root);
                        let found = false;
                        while (stack.length > 0 && !found) {
                            let node = stack.pop();
                            if (!node) continue;
                            if (this.disabled.includes(node.id.toString())) {
                                this.disabledNode.push(node);
                                node.disabled = true;
                                this.disableChildren(node);
                                found = true;
                            }

                            if (node.children) {
                                for (let child of node.children) {
                                    if (this.disabled.includes(child.id.toString())) {
                                        this.disabledNode.push(node);
                                        node.disabled = true;
                                    }
                                    stack.push(child);
                                }
                            }
                        }
                    }
                    this.reload += 1;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        disableChildren(node) {
            let stack = [];
            stack.push(node);

            while (stack.length > 0) {
                let currNode = stack.pop();

                if (currNode.children) {
                    for (let child of currNode.children) {
                        this.disabledNode.push(child);
                        child.disabled = true;
                        stack.push(child);
                    }
                }
            }
        },
    },
});
